var map = {
	"./apple-logo.png": 2583,
	"./calculator.png": 7495,
	"./calendar.png": 3611,
	"./close-hover.png": 8721,
	"./close-normal.png": 8187,
	"./close-press.png": 1851,
	"./default-folder.png": 2709,
	"./finder.png": 9822,
	"./github.png": 6127,
	"./keys/cmd-key.png": 7273,
	"./keys/ctrl-key.png": 8321,
	"./keys/delete-key.png": 2215,
	"./keys/esc-key.png": 3427,
	"./keys/fn-key.png": 5689,
	"./keys/opt-key.png": 7506,
	"./keys/right-tab-key.png": 6500,
	"./keys/shift-key.png": 8352,
	"./mail.png": 2752,
	"./max-hover.png": 7871,
	"./max-normal.png": 9778,
	"./max-press.png": 1615,
	"./memo.png": 817,
	"./message.png": 6592,
	"./min-hover.png": 6102,
	"./min-normal.png": 5477,
	"./min-press.png": 7345,
	"./nofocus.png": 9786,
	"./notion.png": 2759,
	"./photo-booth.png": 7188,
	"./photo.png": 418,
	"./safari.png": 1419,
	"./system-preferences.png": 6122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6003;